module.exports = __webpack_public_path__ + "assets/img/head-in-head.f1079fd4.png";